import React, { Fragment, useContext, useEffect, useState } from 'react'
import { api } from '../../utils/index'
import { Link, useHistory } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import { useWindowSize } from '../../hooks'
import { Button, Card, CardHeader, Col, Progress, Row, Table } from 'reactstrap'
import { volumeReportFilterDataContext } from '../../HOC/volumeReportFiltersContext'
import SetTitle from '../../utils/set_title'
import { notify } from '../../utils/notify'

function VolumeRetrieveListing() {
  SetTitle('Market Screener')
  const [volume_report_schedueld, setVolumeReportScheduled] = useState([])
  const [volume_report, setVolumeReport] = useState([])
  const [schedule_toggle, setScheduleToggle] = useState(true)
  const [pages, setPages] = useState(0)
  let history = useHistory()
  let windowSize = useWindowSize()
  const itemPerPage = 10

  const [filteredData, , getFilteredData, queryParams, actualPage, setActualPage] = useContext(
    volumeReportFilterDataContext
  )

  async function getData() {
    api
      .get('volume-report-scheduled/', {
        params: {
          page_size: 10,
          page: actualPage,
        },
      })
      .then((response) => {
        setScheduleToggle(true)
        setVolumeReportScheduled(response.data.results)
        setPages(Math.ceil(response.data.count / itemPerPage))
      })
  }

  const handleSoftDelete = async (id) => {
    if (!window.confirm('Sei sicuro di voler eliminare questo report?')) {
      return
    }

    try {
      await api.post(`volume-report-scheduled/${id}/soft-delete/`)
      setVolumeReportScheduled((prev) => prev.filter((item) => item.id !== id))
      notify('Report eliminato con successo.', 'success')
    } catch (error) {
      notify(error?.response?.data?.error || 'Impossibile eliminare il report.', 'error')
    }
  }

  function getVolumeReports(id) {
    api
      .get('volume-report/', {
        params: { id, page_size: 10, page: 1 },
      })
      .then(async (response) => {
        const reports = response.data.results
        // fetch the FILLED and total keyword count
        const allStats = await Promise.all(
          reports.map(async (report) => {
            const stats = await fetchKeywordStats(report.schedule_origin)
            return { ...report, stats }
          })
        )
        setScheduleToggle(false)
        setVolumeReport(allStats)
        setPages(Math.ceil(response.data.count / itemPerPage))
      })
      .catch((err) => console.error(err))
  }

  async function fetchKeywordStats(reportId) {
    try {
      const resp = await api.get('keyword-volume/', {
        params: { volume_report_scheduled_id: reportId },
      })
      return {
        totalKeywords: resp.data.total,
        filledKeywords: resp.data.filled,
      }
    } catch (err) {
      console.error('fetchKeywordStats error', err)
      return { totalKeywords: 0, filledKeywords: 0 }
    }
  }

  const handlePageClick = (data) => {
    let path = schedule_toggle ? 'volume-report-scheduled/' : 'volume-report/'
    let currentPage = data.selected + 1
    setActualPage(currentPage)
    if (Object.keys(filteredData).length > 0) {
      getFilteredData({
        ...queryParams,
        page_size: 10,
        page: currentPage,
      })
    } else {
      api
        .get(path, {
          params: {
            page_size: 10,
            page: currentPage,
          },
        })
        .then((response) => {
          if (schedule_toggle) {
            setVolumeReportScheduled(response.data.results)
          } else {
            setVolumeReport(response.data.results)
          }
          setPages(Math.ceil(response.data.count / itemPerPage))
        })
        .catch((error) => console.error(error))
    }
  }

  useEffect(() => {
    if (filteredData.results) {
      setVolumeReportScheduled(filteredData.results)
      setPages(Math.ceil(filteredData.count / itemPerPage))
    } else {
      setPages(0)
      getData()
    }
  }, [filteredData])

  const icon = <i className="fa-solid fa-plus"></i>
  const scheduleTableStyle = { tableLayout: 'fixed', width: '100%' }
  // Name, Cliente, # Runs, Scheduled Left, Last Run, Country, BigQuery Table, Reports, -
  const scheduleColumnWidths = ['15%', '10%', '8%', '8%', '10%', '10%', '22%', '7%', '11%']
  const centeredHeaderStyle = { fontSize: '12px', textAlign: 'center' }
  const ellipsisCellStyle = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }
  const buildBigQueryTableUrl = (tableReference) => {
    const [project, datasetName, bigqueryTableName] = (tableReference || '').split('.')

    if (!project || !datasetName || !bigqueryTableName) {
      return null
    }

    return (
      `https://console.cloud.google.com/bigquery?project=${encodeURIComponent(project)}` +
      `&p=${encodeURIComponent(project)}` +
      `&d=${encodeURIComponent(datasetName)}` +
      `&t=${encodeURIComponent(bigqueryTableName)}` +
      `&page=table`
    )
  }

  return (
    <>
      <Row style={{ marginBottom: '100px' }}>
        <div className="col pb-5">
          <Card className="shadow">
            <CardHeader className="border-0">
              <Row style={{ marginLeft: '0px' }}>
                <Col md={10}>
                  <h1 className="mb-0">Market Screener</h1>
                </Col>
                {schedule_toggle ? (
                  <Col md={2} style={{ textAlign: 'right' }}>
                    <Button
                      style={{ marginRight: '55px' }}
                      color="info"
                      onClick={() => history.push('create-market-screener')}
                      icon={icon}
                    >
                      + Add new
                    </Button>
                  </Col>
                ) : (
                  <Col md={2} style={{ textAlign: 'right' }}>
                    <Button
                      style={{ marginRight: '55px' }}
                      color="warning"
                      onClick={() => getData()}
                      icon={icon}
                    >
                      &#60;- Go Back
                    </Button>
                  </Col>
                )}
              </Row>
            </CardHeader>
            <Table
              className="align-items-center table-flush"
              responsive
              style={schedule_toggle ? scheduleTableStyle : {}}
            >
              {!schedule_toggle ? (
                <>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Name
                      </th>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Status
                      </th>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Date
                      </th>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Only last month
                      </th>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Progress
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {volume_report.map((item, idx) => {
                      let { totalKeywords, filledKeywords } = item.stats

                      // if this is not the last execution, pretend it's fully done
                      const isLast = idx !== 1
                      if (!isLast) {
                        filledKeywords = totalKeywords
                      }
                      const barClass =
                        filledKeywords === totalKeywords ? 'bg-success' : 'bg-warning'

                      return (
                        <tr key={item.id}>
                          <td>{item.name}</td>
                          <td>{item.status}</td>
                          <td>{item.date}</td>
                          <td>{item.only_last_month}</td>
                          <td>
                            <div className="d-flex align-items-center">
                              <div style={{ width: '120px' }}>
                                <Progress
                                  max={totalKeywords}
                                  value={filledKeywords}
                                  barClassName={barClass}
                                />
                              </div>
                              <span style={{ marginLeft: '5px', fontSize: '12px' }}>
                                {filledKeywords}/{totalKeywords}
                              </span>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </>
              ) : (
                <>
                  <colgroup>
                    {scheduleColumnWidths.map((width) => (
                      <col key={width} style={{ width }} />
                    ))}
                  </colgroup>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col" style={{ fontSize: '12px' }}>
                        Name
                      </th>
                      <th scope="col" style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                        Cliente
                      </th>
                      <th scope="col" style={centeredHeaderStyle}>
                        # Runs
                      </th>
                      <th scope="col" style={{ ...centeredHeaderStyle }}>
                        Scheduled Left
                      </th>
                      <th
                        scope="col"
                        style={{ fontSize: '12px', whiteSpace: 'nowrap' }}
                      >
                        Last Run
                      </th>
                      <th
                        scope="col"
                        style={{ fontSize: '12px', whiteSpace: 'nowrap' }}
                      >
                        Country
                      </th>
                      <th scope="col" style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                        BigQuery table
                      </th>
                      <th scope="col" style={centeredHeaderStyle}>
                        Reports
                      </th>
                      <th scope="col" style={{ fontSize: '12px', textAlign: 'center' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {volume_report_schedueld.map((item) => {
                      const bigQueryTableUrl = buildBigQueryTableUrl(item.bq_table_name)

                      return (
                        <tr key={item.id}>
                          <td style={ellipsisCellStyle} title={item.name}>
                            {item.name}
                          </td>
                          <td style={ellipsisCellStyle} title={item.cliente?.nome || '-'}>
                            {item.cliente?.nome || '-'}
                          </td>
                          <td style={{ textAlign: 'center' }}>{item.number_of_runs}</td>
                          <td style={{ textAlign: 'center' }}>
                            {item.remaining_scheduled_executions}
                          </td>
                          <td style={ellipsisCellStyle} title={item.last_run || '-'}>
                            {item.last_run}
                          </td>
                          <td style={ellipsisCellStyle} title={item.locale || '-'}>
                            {item.locale}
                          </td>
                          <td style={ellipsisCellStyle} title={item.bq_table_name}>
                            {bigQueryTableUrl ? (
                              <a
                                href={bigQueryTableUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{
                                  display: 'block',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                {item.bq_table_name}
                              </a>
                            ) : (
                              item.bq_table_name
                            )}
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <Button
                              size="sm"
                              style={{ fontSize: windowSize.width <= 1280 ? '12px' : '13px' }}
                              onClick={() => getVolumeReports(item.id)}
                            >
                              Executions
                            </Button>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <Link to={`/market-screener/edit/${item.id}`}>
                              <Button
                                color="primary"
                                size="sm"
                                style={{ fontSize: windowSize.width <= 1280 ? '12px' : '13px' }}
                              >
                                Edit
                              </Button>
                            </Link>
                            <Button
                              color="danger"
                              size="sm"
                              className="ml-2"
                              style={{ fontSize: windowSize.width <= 1280 ? '12px' : '13px' }}
                              onClick={() => handleSoftDelete(item.id)}
                            >
                              Elimina
                            </Button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </>
              )}
            </Table>
            <ReactPaginate
              previousLabel={'<'}
              nextLabel={'>'}
              breakLabel={'...'}
              pageCount={pages}
              forcePage={actualPage - 1}
              onPageChange={handlePageClick}
              containerClassName={'pagination justify-content-center pt-5 pb-3'}
              pageClassName={'page-item'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              previousLinkClassName={'page-link'}
              nextClassName={'page-item'}
              nextLinkClassName={'page-link'}
              breakClassName={'page-item'}
              breakLinkClassName={'page-link'}
              activeClassName={'active'}
            />
          </Card>
        </div>
      </Row>
    </>
  )
}

export default VolumeRetrieveListing
